<div class="group-page">
  <app-data-table addButtonText="{{ 'GroupsPage.AddButton' | translate }}" title="{{ 'GroupsPage.Title' | translate }}" filterPlaceholder="{{ 'GroupsPage.FilterPlaceholder' | translate }}" (openModal)="openGroup($event)"
      (deleteRow)="deleteGroup($event)" [displayedColumnsName]="displayedColumnsName"
      [displayedColumns]="displayedColumns" [data]="groups">
  </app-data-table>
</div>